import { store } from "../store";
import { setLoginStatus, updateAuthInfo } from "./store/app-actions";
import { getAuthInfo } from "../api/token-storage";

export const setLoginStatusAndAuthInfo = (isLoggedIn: boolean) => {
	store.dispatch(setLoginStatus(isLoggedIn));

	if (isLoggedIn) {
		store.dispatch(updateAuthInfo(getAuthInfo()));
	} else {
		store.dispatch(
			updateAuthInfo({
				name: "",
				displayName: "",
				isAdmin: false
			})
		);
	}
};
